function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#pathstream-user2_svg__clip0_2322_18345)",
  opacity: 0.5
}, React.createElement("path", {
  d: "M407 224c1.444 0 5.708-4.59 6.798-5.426 6.771-5.197 13.833-10.06 21.059-14.673 21.208-13.536 43.889-24.304 67.93-32.457 39.779-13.489 84.633-12.943 123.858 2.065 16.184 6.19 30.041 16.189 46.255 22.245 18.238 6.814 37.708 10.173 57.142 12.066 53.188 5.178 96.005-30.908 136.822-57.621 45.081-29.5 93.001-49.564 148.866-46.975 78.11 3.619 151.18 53.658 184.27 120.776H407z",
  fill: "url(#pathstream-user2_svg__paint0_linear_2322_18345)"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M880.474 53.678l26.971-11.69L902.708 71l10.806-27.338 17.163 23.865-11.689-26.971L948 45.293l-27.339-10.806 23.865-17.165-26.971 11.69L922.292 0l-10.806 27.338-17.165-23.864 11.691 26.972L877 25.71l27.338 10.806-23.864 17.163z",
  fill: "url(#pathstream-user2_svg__paint1_linear_2322_18345)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M937.676 64.73c-2.494-2.408-5.135-4.549-7.604-7.028-.914-.917-1.83-1.837-2.643-2.846-1.2-1.49-2.16-3.157-3.114-4.815l-3.051-5.303c-.183-.318-.369-.71-.194-1.031.203-.375.743-.378 1.152-.256 1.774.53 2.831 2.283 4.016 3.708 1.359 1.635 2.741 3.411 4.856 3.617l-1.135-4.848a70.112 70.112 0 01-4.321-10.992c-.141-.475-.279-.975-.184-1.46.095-.486.501-.95.997-.934.432.014.77.365 1.035.71 2.328 3.034 2.831 6.924 4.947 10.11a453.055 453.055 0 01-3.828-10.207c-.199-.552-.401-1.12-.385-1.707.016-.586.297-1.204.831-1.448 1.269.194 1.991 1.522 2.496 2.703 1.556 3.631 2.833 6.727 3.988 10.506a38.982 38.982 0 00-2.6-7.231c-.711-1.493-1.538-3.035-1.447-4.686.018-.322.091-.677.351-.869.401-.296.97-.03 1.352.29 1.37 1.151 2.045 2.906 2.668 4.584 1.038 2.796 2.12 5.031 3.158 7.826l-3.199-8.751c-.292-.798-.588-1.628-.52-2.474.015-.174.049-.358.169-.485.265-.282.741-.114 1.047.123.804.624 1.271 1.576 1.699 2.5 1.555 3.361 2.686 7.063 3.775 10.58 1.398 4.519 3.697 8.702 5.253 13.183L957 68.46 947.062 77l-9.384-12.26-.002-.01z",
  fill: "#FFB9B9"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1103 195.558c-34.1 24.374-36.34 19.579-65.86 23.442l-8.14-32.911 55.72-2.089 18.28 11.558z",
  fill: "#3B3B3B"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M938.341 237L973 207.294 958.609 186 924 211.138 938.341 237z",
  fill: "#FFC966"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M962 217l-13-24",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M958.106 190L948 250.467 995.123 258 1006 195.461 958.106 190z",
  fill: "#FFDB99"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M960 188.633l.594 54.367 42.406-.704-.24-56.296-42.76 2.633z",
  fill: "#F19700"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M940.948 114.619c-1.525 5.824-4.749 14.927 3.24 17.388 2.902.894 6.008.772 9.042.955 1.732.369 3.144 1.364 4.279 2.895 2.708 3.651 3.847 10.357 4.049 18.887 12.11 1.832 17.202-6.445 21.442-15.94l-6.343-14.188c10.003-20.005-2.193-31.842-14.297-32.447-4.466-.75-9.123 1.06-12.441 4.117-3.319 3.055-5.412 7.231-6.662 11.544-1.435 3.575-5.809 3.623-2.309 6.791v-.002z",
  fill: "#FFB9B9"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M940 118.997c1.543.055 3.209-.611 5-1.997",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M945.034 109.384c-.1.826.029 1.547.286 1.611.257.065.547-.552.646-1.379.1-.826-.029-1.547-.286-1.611-.257-.065-.547.552-.646 1.379zM947.867 105.945c.354 1.024.008 2.093-1.143 2.054-1.182-.041-3.277-1.821-3.643-2.967-.379-1.186.625-2.227 1.821-2.001 1.258.239 2.561 1.749 2.965 2.916v-.002z",
  fill: "#3B3B3B"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1021 150.998c-3.77-13.767-12.82-27.19-23.051-39.57L950.129 56 934 66.956l39.836 55.746 12.469 19.867L1021 151v-.002z",
  fill: "#FFC966"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.008 112.366c-.329-.791-.181-1.701.078-2.519.718-2.259 2.224-4.207 2.899-6.478.158-.532.201-1.239-.283-1.506-.449-.802-1.027-.736-1.93-.9-.903-.165-1.827-.1-2.744-.14a11.859 11.859 0 01-4.518-1.112c-1.485-.698-2.897-1.812-3.376-3.383-.479-1.572.361-3.59 1.971-3.898.4-.077.874-.077 1.118-.403.203-.274.148-.652.087-.986-.155-.864-.267-1.798.118-2.587.482-.994 1.65-1.498 2.752-1.521 1.102-.023 2.171.343 3.223.667.279.088.584.17.858.067.203-.077.356-.247.513-.397 1.045-1.003 2.581-1.355 4.025-1.253 1.444.102 2.824.609 4.175 1.13 3.141 1.212 6.276 2.548 8.979 4.56 1.156.86 2.226 1.84 3.442 2.61 1.933 1.223 4.25 1.929 5.8 3.614 1.676 1.82 2.126 4.674 1.09 6.924 2.745 2.141 4.218 6.01 3.559 9.434-.516 2.693-2.14 4.96-3.664 7.169-.897 1.301-1.902 2.555-2.58 3.992-.31.659-.685 1.482-.68 2.226.005.655.368 1.234.349 1.907-.016.566-.317 1.164-.849 1.352-.355.125-.746.051-1.106-.061-2.754-.861-4.327-3.757-5.156-6.528a4.306 4.306 0 01-3.914-.246c-1.905-1.153-2.585-3.526-3.562-5.531-.785-1.609-1.871-3.105-3.337-4.128-1.146-.8-2.612-1.346-4.025-1.264-1.245.071-2.642.796-3.312-.814v.003z",
  fill: "#3B3B3B"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M988 136.808L983.834 132 953 143.806l1.277 12.564c21.571 7.137 31.941-.537 33.723-19.564v.002z",
  fill: "#FFDB99"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M938.004 158.876l16.015 31.415 5.444 10.671.713 1.401c3.867 11.055 7.599 22.724 12.24 30.308l.005.005c.047.078.093.154.143.229-.046-.074-.09-.148-.136-.22.515.546 1.045 1.08 1.589 1.602 2.877 2.763 5.968 5.09 9.297 6.709l.009.004h.003c.224 0 .45-.011.678-.03l35.286-18.806 7.35-3.918 22.04-11.745c2.01-2.582 1.6-5.668-.37-9.078-3.17-5.483-10.35-11.808-17.97-18.221l-9.19-27.356-7.59-5.91L992.38 131l-18.18 15.1-36.2 12.771.004.005z",
  fill: "#FFDB99"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M938.739 159.002c-4.733 3.596-8.989 10.613-11.84 27.671l-11.128 37.53c-.877 2.957-1.028 6.094-.338 9.098 2.681 11.653 15.052 12.325 23.412 4.585L958 184.982 938.739 159v.002z",
  fill: "#FFC966"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M984 240.473l11.933 33.239 3.93 56.341c1.187 11.606 3.337 21.716 10.497 29.216l13.07 23.919 67.48 11.728-37.22-50.971-3.35-15.099-7.46-50.394 2.93-4.614 27.83 41.126c3.87 12.352 10.72 23.595 21.05 33.543l38.03 53.672L1218 417c-30.11-46.176-60.22-92.338-93.34-115.263l-38.4-52.141c-.79-3.968-2.56-7.88-5.05-11.707-4.66-7.159-11.8-14.026-19.57-20.426a266.647 266.647 0 00-5.13-4.097s-5.48-3.245-8-7.366l-64.508 34.47-.002.003z",
  fill: "#CE740B"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M938.004 158.999l16.003 31.562c.764 3.613 1.609 7.287 2.597 10.938a164.783 164.783 0 00.608 2.179c.104.363.21.726.318 1.088a79.488 79.488 0 00.589 1.926c.037.115.072.232.111.347a78.145 78.145 0 00.626 1.909 76.713 76.713 0 00.402 1.167c.013.032.023.065.036.097.114.328.231.657.351.983.009.021.016.042.024.065a77.495 77.495 0 00.798 2.108c.016.044.035.09.053.134.102.266.21.531.317.797l.05.122a39.787 39.787 0 00.306.747c.043.101.085.199.126.3.113.267.227.534.342.8l.092.209c.13.296.259.588.393.882.039.085.076.17.116.255a71.458 71.458 0 001.817 3.691l.222.415a83.257 83.257 0 00.939 1.68c.092.159.185.319.279.478.1.172.201.34.303.51l.268.437c.097.156.194.314.293.47a89.413 89.413 0 00.596.928c.086.136.178.272.268.407l.076.111c.102.154.208.308.316.462.077.114.155.227.234.34.113.167.231.333.351.498.106.149.214.297.321.446l.328.443.332.439.312.405a23.789 23.789 0 00.701.879c.003.005.007.012.014.017.113.14.229.278.344.418.116.14.236.28.354.42.118.14.24.278.36.416a46.272 46.272 0 001.102 1.22l.006.005h.001s0 .004.004.006h.002c.515.55 1.044 1.087 1.587 1.611 2.875 2.776 5.964 5.114 9.291 6.741h.005l.007.003a25.834 25.834 0 003.327 1.355c.07.025.141.046.21.067.12.041.24.076.361.114.383.113.768.217 1.156.313 0 .002.003.002.005.002l.108.025c.134.033.266.062.398.092.039.008.08.019.12.026.18.037.362.075.542.108a28.469 28.469 0 001.194.193 17.34 17.34 0 00.682.08c.122.014.244.023.367.035h.007c.124.011.249.022.374.029l.372.023c1.339.067 2.712.016 4.117-.165.219-.028.438-.058.655-.092.169-.025.337-.053.506-.08 3.804-.62 7.174-1.811 10.194-3.461.01 0 .01-.004.02-.006a54.694 54.694 0 00.59-.334c.01-.007.02-.015.04-.023.16-.091.31-.183.47-.278.29-.174.58-.356.87-.539.12-.079.25-.163.37-.246.16-.103.32-.211.47-.319.09-.058.18-.118.27-.182.16-.113.33-.232.49-.352l.39-.294c.04-.034.09-.066.13-.099.11-.082.22-.167.32-.252.14-.108.28-.216.42-.327.09-.078.19-.158.29-.239.07-.052.13-.105.19-.156.12-.096.23-.195.34-.292.43-.365.85-.741 1.25-1.125.13-.117.25-.232.37-.35l.36-.356c.1-.092.19-.184.28-.278.14-.138.28-.28.41-.423.35-.358.68-.726 1.02-1.098.14-.161.28-.321.42-.484.12-.134.23-.269.35-.407.54-.632 1.06-1.284 1.56-1.949l.3-.385a.77.77 0 01.08-.111c.13-.183.27-.365.4-.549.32-.434.63-.877.93-1.328.09-.128.18-.257.26-.386.16-.236.32-.473.47-.712.27-.412.54-.832.8-1.255l.39-.638.39-.644a84.1 84.1 0 001.63-2.897c.4-.738.82-1.475 1.25-2.212 2.87-4.887 6.49-9.651 10.71-13.297 3.17-2.743 6.91-5.364 10.94-7.621 7.38-4.142 15.75-7.081 23.5-7.379 5.4-.207 10.77.746 16.09 1.693 5.11.912 10.62 1.527 15.18 4.004-2.86-7.835-11.06-12.576-19.22-14.181-8.16-1.606-16.57-.728-24.88-.907-8.31-.179-19.72.446-23.43-7.023-5.53-11.144-10.55-17.917-14.38-21.996a37.885 37.885 0 00-1.93-1.925v-.005c-3.44-3.211-5.54-3.968-5.65-4.006L992.34 131l-18.166 15.171c-14.476 3.881-28.072 7.908-36.174 12.83l.004-.002z",
  fill: "#FFC966"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M957 201.06c-.83-3.02-1.56-6.056-2.229-9.06L938 238M1019 230l34-19",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953 133.207c1.715.356 3.114 1.316 4.238 2.793l5.762-4-10 1.207z",
  fill: "#3B3B3B"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M959 66l-17 12M1046 226.096l14.61 22.321 5.9.524a14.936 14.936 0 0015.16-9.266l.33-.807c-4.75-7.314-12.03-14.33-19.96-20.868l-16.04 8.094v.002z",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M958.075 123.192a8.032 8.032 0 01-3.932-10.628 7.97 7.97 0 0110.594-3.919c4.011 1.853 5.772 6.611 3.932 10.628a7.969 7.969 0 01-10.594 3.919z",
  fill: "#FFB9B9"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M967.91 117c.57-3.253-1.633-6.345-4.921-6.911-3.289-.564-6.417 1.614-6.989 4.865M962 110l-4 8",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1157.64 80.725l4.05-37.094-37.09-4.08-4.05 37.094 37.09 4.08z",
  stroke: "#3B3B3B"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M860.47 71.857l-15.781 16.466M862.505 73.597c-3.981 6.59-9.573 12.171-14.816 16.726M865.505 77.597c-3.175 4.985-8.37 10.647-14.816 16.726",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M842.474 84.693c-3.892-5.306-9.29-4.538-15.026-5.152-3.686-.394-7.414-.798-10.908-2.044-5.169-1.845-9.65-5.557-12.422-10.29-4.256-7.268-3.287-14.397-.951-21.991 1.388-4.515 4.397-8.854 7.999-11.907 8.439-7.145 22.041-8.995 31.99-3.699 5.772 3.074 10.269 8.656 11.544 15.061.581 2.918.507 5.926.252 8.888-.24 2.785-.639 5.58-.417 8.37.223 2.79 1.143 5.638 3.16 7.585l-15.22 15.177-.001.002z",
  fill: "url(#pathstream-user2_svg__paint2_linear_2322_18345)"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M853.46 74.992l-17.296-20.98c-1.928-2.339.915-5.593 3.486-3.968a2.66 2.66 0 011.003 3.402l-1.807 3.82-5.649 5.258-3.043-3.466c-1.507-1.717-4.375-1.042-4.834 1.172l-.016.079c-.374 1.941 1.432 3.631 3.383 3.204l4.512-.989 15.844 16.83",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.45,
  d: "M816.972 58.195c.583.935 1.256 1.856 1.473 2.945.377 1.902-.878 3.947-2.663 4.645-1.786.699-3.91.134-5.287-1.199-.845-.818-1.425-1.877-1.924-2.951-1.665-3.586-4.254-10.896 1.319-12.492 4.909-1.404 5.222 6.07 7.08 9.053l.002-.001zM827.058 69.452c.565.585.892 1.477.574 2.221-.224.524-.722.883-1.244 1.116-1.277.569-2.777.51-4.107.066-1.071-.359-2.09-.99-2.701-1.938-1.083-1.679-.301-4.382 1.958-4.38 1.464.002 4.564 1.923 5.52 2.915z",
  fill: "#fff"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M858.565 68.96c1.999.29 3.339.928 2.731 2.593l1.594 1.97c2.887.228 4.272 1.362 3.231 3.955-.443 7.977-5.576 13.288-14.784 16.281-2.92-.361-3.966-1.526-3.094-3.514l-2.49-2.548c-2.542.628-2.73-1.314-2.792-3.392l15.604-15.346z",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M866.508 151.65a8.469 8.469 0 017.741-1.263l-10.396-14.392 14.127-10.533a8.543 8.543 0 01-6.952-3.565c-2.808-3.888-1.983-9.352 1.844-12.205 3.826-2.852 9.204-2.014 12.012 1.874a8.836 8.836 0 011.262 7.808l14.127-10.533L927 145.845l-13.024 9.711a8.823 8.823 0 00-1.424-7.213c-2.808-3.888-8.187-4.726-12.012-1.874-3.827 2.852-4.652 8.318-1.844 12.204a8.533 8.533 0 006.345 3.544L890.581 173l-10.396-14.392c.023 2.711-1.19 5.396-3.507 7.123-3.827 2.853-9.205 2.015-12.012-1.873-2.808-3.889-1.983-9.353 1.844-12.205l-.002-.003z",
  fill: "#fff"
});

var _ref31 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#pathstream-user2_svg__a)"
}, React.createElement("path", {
  d: "M866.508 151.65a8.469 8.469 0 017.741-1.263l-10.396-14.392 14.127-10.533a8.543 8.543 0 01-6.952-3.565c-2.808-3.888-1.983-9.352 1.844-12.205 3.826-2.852 9.204-2.014 12.012 1.874a8.836 8.836 0 011.262 7.808l14.127-10.533L927 145.845l-13.024 9.711a8.823 8.823 0 00-1.424-7.213c-2.808-3.888-8.187-4.726-12.012-1.874-3.827 2.852-4.652 8.318-1.844 12.204a8.533 8.533 0 006.345 3.544L890.581 173l-10.396-14.392c.023 2.711-1.19 5.396-3.507 7.123-3.827 2.853-9.205 2.015-12.012-1.873-2.808-3.889-1.983-9.353 1.844-12.205l-.002-.003z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M867.39 104.947L931 112l-6.99 64.623-63.61-7.053 6.99-64.623z",
  fill: "url(#pathstream-user2_svg__paint3_linear_2322_18345)"
}));

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1115.43 147.354L1162 159l-6.99 28.146-46.56-11.646 6.98-28.146z",
  fill: "#FFC966"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1161.73 159.211l-26.77 8.151-19.82-19.764",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1062.81 78.266l21.35 8.63c11.3 4.563 16.67 17.532 12.01 28.967-4.66 11.434-17.59 17.005-28.88 12.442l-14.35-5.795-8.32 8.795-.21-12.312c-10.25-5.071-14.94-17.376-10.49-28.285 4.66-11.434 17.59-17.005 28.89-12.442z",
  fill: "url(#pathstream-user2_svg__paint4_linear_2322_18345)"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M802.538 203.431L792 167.517 829.087 166l-6.457 9.104L848 192.432 834.874 212l-25.878-17.673-6.458 9.104z",
  stroke: "#3B3B3B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "pathstream-user2_svg__paint0_linear_2322_18345",
  x1: 803.5,
  y1: 96.46,
  x2: 803.5,
  y2: 281.475,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.401,
  stopColor: "#8ADEA1"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "pathstream-user2_svg__paint1_linear_2322_18345",
  x1: 949.684,
  y1: 35.501,
  x2: 896.961,
  y2: 35.501,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.02,
  stopColor: "orange"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDB99"
})), React.createElement("linearGradient", {
  id: "pathstream-user2_svg__paint2_linear_2322_18345",
  x1: 838.334,
  y1: 27.661,
  x2: 824.311,
  y2: 79.808,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.368,
  stopColor: "#FFDB99"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC966"
})), React.createElement("linearGradient", {
  id: "pathstream-user2_svg__paint3_linear_2322_18345",
  x1: 927.51,
  y1: 144.291,
  x2: 863.88,
  y2: 137.409,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.02,
  stopColor: "#FFB733"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDB99"
})), React.createElement("linearGradient", {
  id: "pathstream-user2_svg__paint4_linear_2322_18345",
  x1: 1076.28,
  y1: 82.484,
  x2: 1048.72,
  y2: 133.516,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFB733"
}), React.createElement("stop", {
  offset: 0.615,
  stopColor: "#FFDB99"
})), React.createElement("clipPath", {
  id: "pathstream-user2_svg__clip0_2322_18345"
}, React.createElement("path", {
  d: "M0 108.328h1200V212c0 6.627-5.37 12-12 12H0V108.328z",
  fill: "#fff"
})), React.createElement("clipPath", {
  id: "pathstream-user2_svg__clip1_2322_18345"
}, React.createElement("path", {
  d: "M1200 0H601v212c0 6.627 5.373 12 12 12h587V0z",
  fill: "#fff"
})));

var SvgPathstreamUser2 = function SvgPathstreamUser2(props) {
  return React.createElement("svg", _extends({
    width: 1200,
    height: 224,
    viewBox: "0 0 1200 224",
    fill: "none"
  }, props), _ref, React.createElement("g", {
    clipPath: "url(#pathstream-user2_svg__clip1_2322_18345)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, React.createElement("mask", {
    id: "pathstream-user2_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 863,
    y: 108,
    width: 64,
    height: 65
  }, _ref30), _ref31, _ref32, _ref33, _ref34, _ref35), _ref36);
};

export default __webpack_public_path__ + "6b7e7d0f7a7c59a1fd328a671e04905c.svg";
export { SvgPathstreamUser2 as ReactComponent };